<script setup lang="ts">
import QitBtn from "@/shared/components/buttons/qit-button.vue";
import { useAbilityRoute } from "@/shared/environment/ability-route";
import { encodeParamArrayToString } from "@/shared/environment/ability-route-helper";
import { CommonRouteAliases } from "@/shared/environment/common-route-aliases";
import WidgetCard from "@/shared/components/widgets/widget-card.vue";

const { getPathToChild } = useAbilityRoute();

// enter combined view with root assembly ""
const combinedViewPath = getPathToChild(CommonRouteAliases.mechanicCombinedView, {
    [CommonRouteAliases.mechanicCombinedView]: encodeParamArrayToString([""]),
});
</script>

<template>
    <WidgetCard
        icon="fa-light icon-light-color fa-table-layout q-mr-sm"
        :title="$t('mechanic.enter_combined_view_widget_title')"
        :description="$t('mechanic.enter_combined_view_widget_description')"
    >
        <template #button>
            <router-link class="router-link flex flex-end" :to="combinedViewPath">
                <QitBtn
                    color="secondary"
                    data-qs="enter-combined-view-widget-button"
                    :label="$t('mechanic.enter_combined_view_widget_button_text')"
                    :disabled="false"
                />
            </router-link>
        </template>
    </WidgetCard>
</template>
